function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".data-cell-item_tooltip", shadowSelector, " {position: fixed;top: 380px;left: 700px;min-width: 10rem;}"].join('');
}
export default [stylesheet];